import React, { useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const ModalConfirmacaoSenha = ({ show, mensagem, onConfirm, onCancel }) => {
  const [senha, setSenha] = useState('');
  const [processando, setProcessando] = useState(false);

  const confirmar = async () => {
    if (!senha) {
      toast.warn('Informe a senha');
      return;
    }
    setProcessando(true);
    try {
      await api.validarSenhaUsuario(senha);
      await onConfirm();
      setSenha('');
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao confirmar operação';
      toast.error(msg);
    } finally {
      setProcessando(false);
    }
  };

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirmação</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{mensagem}</p>
        <Form.Group>
          <Form.Label>Senha</Form.Label>
          <Form.Control
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={processando}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={confirmar} disabled={processando}>
          {processando ? <Spinner animation="border" size="sm" /> : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmacaoSenha;
